import { render, staticRenderFns } from "./carDetailFee.vue?vue&type=template&id=6e50fc17&scoped=true"
import script from "./carDetailFee.vue?vue&type=script&lang=js"
export * from "./carDetailFee.vue?vue&type=script&lang=js"
import style0 from "./carDetailFee.vue?vue&type=style&index=0&id=6e50fc17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e50fc17",
  null
  
)

export default component.exports